module.exports = __webpack_public_path__ + "static/media/3.Inner Pattern.c4254de6.jpg";